import styled from "@emotion/styled"
import { Grid } from "@mui/material"
import * as api from "api"
import { memo, useState } from "react"
import Shared from "theme/shared"
import Promotion from "./Promotion"
import PromotionDialog from "./dialogs/PromotionDialog"

const Styled = {
  Wrapper: styled.div`
    padding: 10px 15px;
  `,
  Headline: styled(Shared.Header)`
    text-align: left; // flipped for mui
    margin-top: 0;
  `,
  List: styled(Grid)<{ component: string }>`
    padding: 15px 0;
    list-style: none;
    gap: 30px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      gap: 0;
    }
  `,
  ListItem: styled(Grid)<{ component: string }>`
    width: 100%;
    ${(p) => p.theme.breakpoints.down("sm")} {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  `,
}

type PromotionsProps = { serviceCenter: api.SingleServiceCenter }

const Promotions = ({ serviceCenter }: PromotionsProps) => {
  const [activeBenefit, setActiveBenefit] = useState<api.Benefit | null>(null)

  if (!serviceCenter.benefits.length) return null

  return (
    <Styled.Wrapper>
      <Styled.Headline>ההטבות שלנו</Styled.Headline>
      <Styled.List container component="ul">
        {serviceCenter.benefits.map((item, i) => (
          <Styled.ListItem component="li" key={i} item xs={12} sm={3}>
            <Promotion
              benefit={item}
              onBenefitClick={() => setActiveBenefit(item)}
            />
          </Styled.ListItem>
        ))}
      </Styled.List>
      <PromotionDialog
        onClose={() => setActiveBenefit(null)}
        benefit={activeBenefit}
      />
    </Styled.Wrapper>
  )
}

export default memo(Promotions)
